/*
 * 首页页面名词
 *
 * @Author:    1024创新实验室-主任：卓大
 * @Date:      2022-09-06 19:56:43
 * @Wechat:    zhuda1024
 * @Email:     lab1024@163.com
 * @Copyright  1024创新实验室 ( https://1024lab.net )，Since 2012
 */

//首页页面名字
export const HOME_PAGE_NAME = 'Home';

//首页页面路径
export const HOME_PAGE_PATH = '/home';
